import { createContext, useContext, useState } from "react";

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
  const [filters, setFilters] = useState({
    selectedYearMonth: "",
    selectedMonth: "",
    selectedMonthLabel: "",
    selectedDivision: "",
    selectedTerritory: "",
  });

  const [data, setData] = useState({
    dashboardData: null,
    employees: [],
  });

  // Dropdowns stored in context so they survive navigation to/from employee detail
  const [dropdowns, setDropdowns] = useState({
    months: [],
    divisions: [],
    territories: [],
  });

  const [scrollPosition, setScrollPosition] = useState(0);

  return (
    <DashboardContext.Provider
      value={{
        filters,
        setFilters,
        data,
        setData,
        dropdowns,
        setDropdowns,
        scrollPosition,
        setScrollPosition,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error("useDashboard must be used inside DashboardProvider");
  }
  return context;
}

